/** Looker's logo URL. Kept separate from `looker-ai`'s registration so the MCP
 * server spec can use it without registering the integration. */
export const LookerAiIconUrl =
  "https://www.gstatic.com/cloud/images/navigation/looker.svg";
